import styles from './CardProduzido.module.scss';
import { formataData } from "../../../utils/formatacao";
import { IProcesso } from '../../../interfaces/processo.interface';
import QRCodeComponent from '../../QRcode';

// Ícones
import { TbInfoOctagonFilled } from "react-icons/tb";
import { FcStatistics } from "react-icons/fc";
import { MdQrCodeScanner } from "react-icons/md";
import { useState } from 'react';

interface Props {
    processo: IProcesso;
    infoRastreabilidade: () => void;
    infoGastosProdutivos: () => void;
}

export default function CardProduzido({ processo, infoRastreabilidade, infoGastosProdutivos }: Props) {
    const [qrCode, setQrCode] = useState<boolean>(false);

    return (
        <div className={styles.container}>
            <h3 className={styles.info}>Produto: <span>{processo.produto}</span></h3>
            <h3 className={styles.info}>Início: <span>{formataData(processo.inicio)}</span></h3>
            <h3 className={styles.info}>Fim: <span>{formataData(processo.fim)}</span></h3>
            <div className={styles.icons}>
                <TbInfoOctagonFilled
                    className={styles.icon}
                    style={{ color: 'rgb(128, 125, 125)', cursor: 'pointer' }}
                    onClick={infoRastreabilidade}
                />
                <FcStatistics
                    className={styles.icon}
                    style={{ cursor: 'pointer' }}
                    onClick={infoGastosProdutivos}
                />
                <MdQrCodeScanner
                    className={styles.icon}
                    style={{ color: 'rgb(128, 125, 125)', cursor: 'pointer' }}
                    onClick={() => setQrCode(!qrCode)} // Alterna a visualização do QR code
                />
            </div>

            {/* Renderiza o QR code apenas quando o estado qrCode for true */}
            {qrCode && (
                <div className={styles.qrCodeContainer}>
                    <QRCodeComponent value={`http://localhost:3001/rastreabilidade/${processo.id}`} />
                </div>
            )}
        </div>
    );
}

